import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import createSelector from 'helpers/createSelector';
import moment from 'moment';
import _ from 'lodash';
import { Button, Row, Col, Icon, message } from 'antd';
import { actions } from 'modules/modal'
import Truncate from 'react-truncate-dom';

import { setCollection, deleteCollection } from 'modules/collection/actions';
import striptags from 'striptags';
import { routeActions } from 'react-router-redux';
import { logAsync } from 'helpers/elogAsync';

import './style.css';
const avatarUrl = require('./images/avatar.png');

class FeedItem extends Component {


  static propTypes = {
    data: PropTypes.object,
    dispatch: PropTypes.func,
  };

  state = {
    data: {},
  };



  handleClick = (data) => {
    const {dispatch, toHtml, showTraditionalContent} = this.props;
    if ((!showTraditionalContent && _.get(data, 'isTraditional', false)) || data.mediaType == 'news') {
      dispatch(actions.setIsRead(data));
      window.open(data.url);
    } else {
      dispatch(actions.toggleArticleModal(data));
    }
  };

  handleCluster = (query) => {
    const { dispatch } = this.props;
    dispatch(routeActions.push({
      pathname: '/search',
      query: {
        ...query
      }
    }))
    .then(() => {
      const {register_email} = localStorage;
      logAsync({
        type: 'sPOP-search',
        data: {
          query,
          user: register_email
        }
      })
    })
  }

  replaceBr = (str) => {
    return str.replace(/<br\s*\/?>/gi, "");
  };

  handleAddToClip = (globalId) => {
    const { dispatch } = this.props;
    dispatch(setClipping({
      type: 'ADD',
      globalId: [globalId]
    }))
    .then(() => {
      const {register_email} = localStorage;
      logAsync({
        type: 'sPOP-add-collection',
        data: {
          globalId: [globalId],
          user: register_email
        }
      })
      message.success(t('commonClippingSuccess'))
    });
  };

  renderNews(data) {
    const { dataIsRead, dispatch, clipping } = this.props;
    const id = data.globalId;
    const disabled = _.includes(clipping, id)
    moment.locale('en', {
                relativeTime: {
                  future: "in %s",
                  past: "%s前",
                  s: "%d 秒",
                  m: "%d 分鐘",
                  mm: "%d 分鐘",
                  h: "%d 小時",
                  hh: "%d 小時",
                  d: "%d 天",
                  dd: "%d 天",
                  M: "%d 月",
                  MM: "%d 月",
                  y: "%d 年",
                  yy: "%d 年"
                }
              })


    return (
      <div style={{ padding: '0 10px' }}>
        <div className={classnames('latest-feed', { 'read': _.includes(dataIsRead, data.globalId) })}>
          <div>
            <div className="cursor-pointer" onClick={(e) => { e.stopPropagation(); this.handleClick(data) }}>
              <a
                title={data.title}
                onClick={(e) => { e.stopPropagation(); this.handleClick(data) }}
                className={classnames({ 'readText': _.includes(dataIsRead, data.globalId) })}
              >
                <Truncate
                  className="latest-feed-title"
                  html={data.title}
                />
              </a>

                <span className="pull-right">{moment(data.date).fromNow()}</span>


            </div>
            <div className="clearfix margin-top-sm latest-feed-source">
              <span className="pull-left">
                <span>{t('subjectMonitoringFeedFrom')} </span>
                <a onClick={() => { this.handleCluster({ mediaType: data.mediaType, from: data.from }) }}>
                  {data.from}
                </a>
                <span> - </span>
                <a onClick={() => { this.handleCluster({ mediaType: data.mediaType, from: data.from, in: data.in }) }}>
                  {data.in}
                </a>
              </span>
              {data.mediaType === 'forum' &&
                <span className="pull-right">
                  <span title={t('commonHits')} className="margin-right-md">
                    <Icon type="eye-o" className="margin-right-md" />
                    {data.hits}
                  </span>
                  <span title={t('commonComments')} className="margin-right-md">
                    <Icon type="message" className="margin-right-md" />
                    {data.comments}
                  </span>
                </span>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderFacebook(data) {
    const { dataIsRead, dispatch, clipping, hideFrom } = this.props;
    const id = data.globalId;
    const disabled = _.includes(clipping, id);
    return (
      <Row className={classnames('latest-feed', { 'read': _.includes(dataIsRead, data.globalId) })}>
        <Col span="3">
          <div className="avatar">
            <img
              src={`https://graph.facebook.com/${_.get(data, 'fromId')}/picture`}
              ref={(avatar) => {
                if (avatar) {
                  avatar.onerror = () => {
                    avatar.src = avatarUrl;
                  }
                }
              }}
            />
          </div>
        </Col>
        <Col span="21" className={classnames({ "padding-left-md": hideFrom })}>
          <a
            title={data.content}
            onClick={() => this.handleClick(data)}
            className={classnames({ 'readText': _.includes(dataIsRead, data.globalId) })}>
            <Truncate
              className="latest-feed-content"
              line={1}
              html={data.content}
            />
          </a>
          <div className="clearfix margin-top-sm latest-feed-source">
            <span className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <a title={data.by} onClick={() => { this.handleCluster({ mediaType: data.mediaType, from: data.from }) }}>
                {hideFrom &&
                  <Truncate
                    style={{
                      display: 'inline-block',
                      width: '40px'
                    }}
                    line={1}
                    html={data.by}
                  />
                  ||
                  <span>{data.by}</span>
                }
              </a>
              {!hideFrom &&
                <span> @ </span>
              }
              {!hideFrom &&
                <a onClick={() => { this.handleCluster({ mediaType: data.mediaType, from: data.from }) }}>{data.from}</a>
              }
              <span className="pull-right margin-left-md">{moment(data.date).fromNow()}</span>
            </span>
            <span className="pull-right">
              <span title={t('commonComments')} className="margin-right-md">
                <Icon type="message" className="margin-right-md" />
                {data.comments}
              </span>
              <span title={t('commonLikes')} className="margin-right-md">
                <Icon type="like" className="margin-right-md" />
                {data.likes}
              </span>
              <span title={t('commonShares')} className="margin-right-md">
                <Icon type="share-alt" className="margin-right-md" />
                {data.shares}
              </span>
            </span>
          </div>
        </Col>
      </Row>
    )
  }

  renderWeibo(data) {
    const { dataIsRead, dispatch, clipping } = this.props;
    const id = data.globalId;
    const disabled = _.includes(clipping, id)
    return (
      <Row className={classnames('latest-feed', { 'read': _.includes(dataIsRead, data.globalId) })}>
        <Col span="24">
          <Row>
            <Col span="23">
              <a
                title={data.content}
                onClick={() => this.handleClick(data)}
                className={classnames({ 'readText': _.includes(dataIsRead, data.globalId) })}>
                <Truncate
                  className="latest-feed-content"
                  html={data.content}
                />
              </a>
            </Col>
            <Col span="1" className="clearfix">
            </Col>
          </Row>
          <div className="clearfix margin-top-sm latest-feed-source">
            <span className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <a onClick={() => { this.handleCluster({ mediaType: data.mediaType, from: data.from }) }}>{data.from}</a>
              <span className="pull-right margin-left-md">{moment(data.date).fromNow()}</span>
            </span>
            <span className="pull-right">
              <span title={t('commonComments')} className="margin-right-md">
                <Icon type="message" className="margin-right-md" />
                {data.comments}
              </span>
              <span title={t('commonLikes')} className="margin-right-md">
                <Icon type="like" className="margin-right-md" />
                {data.likes}
              </span>
              <span title={t('commonShares')} className="margin-right-md">
                <Icon type="share-alt" className="margin-right-md" />
                {data.shares}
              </span>
            </span>
          </div>
        </Col>
      </Row>
    )
  }

  renderPixnet(data) {
    const { dataIsRead, dispatch, clipping } = this.props;
    const id = data.globalId;
    const disabled = _.includes(clipping, id)
    return (
      <Row className={classnames('latest-feed', { 'read': _.includes(dataIsRead, data.globalId) })}>
        <Col span="24">
          <Row>
            <Col span="23">
              <a
                title={data.title}
                onClick={() => this.handleClick(data)}
                className={classnames({ 'readText': _.includes(dataIsRead, data.globalId) })}
              >
                <Truncate
                  className="latest-feed-title"
                  html={data.title}
                />
              </a>
              <div className={classnames("latest-feed-description", { 'readText': _.includes(dataIsRead, data.globalId) })}>
                <Truncate
                  line={3}
                  html={data.content}
                />
              </div>
            </Col>
            <Col span="1" className="clearfix">
              {disabled &&
                <Button size="small" className="pull-right" disabled={true}>{t('commonCliped')}</Button>
                ||
                <Button size="small" className="pull-right" onClick={() => this.handleAddToClip(data.globalId)}>{t('commonClipping')}</Button>
              }
            </Col>
          </Row>
          <div className="clearfix margin-top-sm latest-feed-source">
            <span className="pull-left feed-tag feed-tag-info margin-right-md">{t(data.mediaType)}</span>
            <span className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <a onClick={() => { this.handleCluster({ mediaType: data.mediaType, from: data.from }) }}>{data.from}</a>
              <span> - </span>
              <a onClick={() => { this.handleCluster({ mediaType: data.mediaType, from: data.from, in: data.in }) }}>{data.in}</a>
              <span> - </span>
              <a onClick={() => { this.handleCluster({ mediaType: data.mediaType, from: data.from, in: data.in, by: data.by }) }}>{data.by}</a>
              <span> {t('subjectMonitoringFeedAt')} </span>
              <span>
                {moment(data.date).format('YYYY-MM-DD HH:mm')}
              </span>
            </span>
            <span className="pull-right">
              <span title={t('commonComments')} className="margin-right-md">
                <Icon type="eye-o" className="margin-right-md" />
                {data.comments}
              </span>
              <span title={t('commonHits')} className="margin-right-md">
                <Icon type="like" className="margin-right-md" />
                {data.hits}
              </span>
            </span>
          </div>
        </Col>
      </Row>
    )
  }

  renderYoutube(data) {
    const { dataIsRead, dispatch, clipping } = this.props;
    const id = data.globalId;
    const disabled = _.includes(clipping, id)
    return (
      <Row className={classnames('latest-feed', { 'read': _.includes(dataIsRead, data.globalId) })}>
        <Col span="24">
          <Row>
            <Col span="23">
              <a
                title={data.title}
                onClick={() => this.handleClick(data)}
                className={classnames({ 'readText': _.includes(dataIsRead, data.globalId) })}
              >
                <Truncate
                  className="latest-feed-title"
                  html={data.title}
                />
              </a>
              <div className={classnames("latest-feed-description", { 'readText': _.includes(dataIsRead, data.globalId) })}>
                <Truncate
                  line={3}
                  html={data.content}
                />
              </div>
            </Col>
            <Col span="1" className="clearfix">
              {disabled &&
                <Button size="small" className="pull-right" disabled={true}>{t('commonCliped')}</Button>
                ||
                <Button size="small" className="pull-right" onClick={() => this.handleAddToClip(data.globalId)}>{t('commonClipping')}</Button>
              }
            </Col>
          </Row>
          <div className="clearfix margin-top-sm latest-feed-source">
            <span className="pull-left feed-tag feed-tag-info margin-right-md">{t(data.mediaType)}</span>
            <span className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <a onClick={() => { this.handleCluster({ mediaType: data.mediaType, from: data.from }) }}>{data.from}</a>
              <span> - </span>
              <a onClick={() => { this.handleCluster({ mediaType: data.mediaType, from: data.from, in: data.in, by: data.by }) }}>{data.by}</a>
              <span> {t('subjectMonitoringFeedAt')} </span>
              <span>
                {moment(data.date).format('YYYY-MM-DD HH:mm')}
              </span>
            </span>
            <span className="pull-right">
              <span title={t('commonHits')} className="margin-right-md">
                <Icon type="eye-o" className="margin-right-md" />
                {data.hits}
              </span>
              <span title={t('commonComments')} className="margin-right-md">
                <Icon type="eye-o" className="margin-right-md" />
                {data.comments}
              </span>
              <span title={t('commonLikes')} className="margin-right-md">
                <Icon type="like" className="margin-right-md" />
                {data.likes}
              </span>
            </span>
          </div>
        </Col>
      </Row>
    )
  }

  renderWechat(data) {
    const { dataIsRead, dispatch, clipping } = this.props;
    const id = data.globalId;
    const disabled = _.includes(clipping, id)
    return (
      <Row className={classnames('latest-feed', { 'read': _.includes(dataIsRead, data.globalId) })}>
        <Col span="24">
          <div>
            <a
              title={data.title}
              onClick={() => this.handleClick(data)}
              className={classnames({ 'readText': _.includes(dataIsRead, data.globalId) })}>
              <Truncate
                className="latest-feed-title"
                html={data.title}
              />
            </a>
          </div>
          <div className="margin-top-sm clearfix latest-feed-source">
            <span className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <a onClick={() => { this.handleCluster({ mediaType: data.mediaType, from: data.from }) }}>
                {data.from}
              </a>
              <span className="pull-right margin-left-md">{moment(data.date).fromNow()}</span>
            </span>
            <span className="pull-right">
              <span title={t('commonHits')} className="margin-right-md">
                <Icon type="eye-o" className="margin-right-md" />
                {data.hits}
              </span>
              <span title={t('commonLikes')} className="margin-right-md">
                <Icon type="like" className="margin-right-md" />
                {data.likes}
              </span>
            </span>
          </div>
        </Col>
      </Row>
    )
  }

  renderTwitter(data) {
    const { dataIsRead, dispatch, clipping } = this.props;
    const id = data.globalId;
    const disabled = _.includes(clipping, id)
    return (
      <Row className={classnames('latest-feed', { 'read': _.includes(dataIsRead, data.globalId) })}>
        <Col span="2">
          <div className="avatar">
            <img
              src={data.byImageUrl}
              ref={(avatar) => {
                if (avatar) {
                  avatar.onerror = () => {
                    avatar.src = avatarUrl;
                  }
                }
              }}
            />
          </div>
        </Col>
        <Col span="22">
          <Row>
            <Col span="22">
              <div>
                <a
                  title={data.content}
                  onClick={() => this.handleClick(data)}
                  className={classnames({ 'readText': _.includes(dataIsRead, data.globalId) })}>
                  <Truncate
                    line={1}
                    className="latest-feed-content"
                    html={data.content}
                  />
                </a>
              </div>
            </Col>
            <Col span="2" className="clearfix">
            </Col>
          </Row>
          <div className="clearfix margin-top-sm latest-feed-source">
            <span className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <a onClick={() => { this.handleCluster({ mediaType: data.mediaType, in: data.in, by: data.by }) }}>{data.by}</a>
              {data.in && <span> @ </span>}
              <a onClick={() => { this.handleCluster({ mediaType: data.mediaType, in: data.in }) }}>{data.in}</a>
              <span className="pull-right margin-left-md">{moment(data.date).fromNow()}</span>
            </span>
            <span className="pull-right">
              <span title={t('commonComments')} className="margin-right-md">
                <Icon type="message" className="margin-right-md" />
                {data.shares}
              </span>
              <span title={t('commonLikes')} className="margin-right-md">
                <Icon type="like" className="margin-right-md" />
                {data.likes}
              </span>
            </span>
          </div>

        </Col>
      </Row>
    )
  }

  renderItem(data) {
    switch (data.mediaType) {
      case 'news':
      case 'forumComment':
      case 'forum':
      case 'blog':
      case 'video':
      case 'macautalk':
        return this.renderNews(data);
        break;
      case 'pixnet':
        return this.renderPixnet(data);
        break;
      case 'youtube':
        return this.renderYoutube(data);
        break;
      case 'weibo':
        return this.renderWeibo(data);
        break;
      case 'facebook':
        return this.renderFacebook(data);
        break;
      case 'wechat':
        return this.renderWechat(data);
        break;
      case 'twitter':
        return this.renderTwitter(data);
        break;
      default:
        return this.renderNews(data);
        break;
    }
  }

  render() {
    const { data } = this.props;
    return (
      <div className="padding-left-xmd padding-right-xmd">
        <div>{this.renderItem(data)}</div>
      </div>
    );
  }
}

const container = connect(
  createSelector(
    (state) => ({
      dataIsRead: _.get(state, 'modal.dataIsRead'),
      toHtml: _.get(state, 'sourceGroup.toHtml'),
      clipping: _.get(state, 'clipping.globalIds'),
      me: _.get(state, 'me'),
    })
    ,
    (state) => {
      const showTraditionalContent = _.get(state, 'me.permission.showTraditionalContent', false);
      return {
        dataIsRead: state.dataIsRead,
        clipping: state.clipping,
        toHtml: state.toHtml,
        showTraditionalContent
      }
    }
  )
);

export default container(FeedItem);



/** WEBPACK FOOTER **
 ** ./src/app/modules/feed/components/LatestFeedItem.js
 **/